import Definition from '@client/config/definition';
import { distanceMToOther } from '@client/helper/distance';
import * as corosSportConfig from '@coros/sport-config';
const { isIndoorClimbOrBoulderingTrainingSportType } = corosSportConfig.sport.climb;

/**
 * 计算预估数据
 */
export function getCalculateInfo({
  currentDaySum,
  distance,
  distanceDisplayUnit,
  duration,
  pitch,
  sets,
  trainingLoad,
  currentUnit,
  program
}) {
  const resData = {};
  if (currentDaySum) {
    resData.currentDaySum = currentDaySum;
  }
  // 转换距离数值
  if (Number(distance) > 0) {
    const unitName = Definition.getTargetUnitNameByType(
      distanceDisplayUnit,
      {
        0: 'km',
        1: 'mi'
      }[currentUnit]
    );
    resData.distanceUnitName = unitName;
    resData.distance = distanceMToOther(unitName, Number(distance) / 100);
    // 距离单位为米或 yard 时，取整
    if (['m', 'yd'].includes(unitName)) {
      resData.distance = Math.round(resData.distance);
    }
  }
  if (trainingLoad) {
    resData.trainingLoad = Math.round(trainingLoad);
  }

  // 室内攀岩、抱石
  if (isIndoorClimbOrBoulderingTrainingSportType(program.sportType)) {
    /**
     *   1. 若动作均为时间，显示时间（00:00/00:00:00）
          2. 若动作均为线路，显示线路数
          3. 若动作均为自由模式，显示线路数（线路数等于动作数）
          4. 若动作目标不一致，显示线路数（n条）
            1. 目标类型为时间、自由模式时，一个动作默认为一条线路
            2. 目标类型为线路时，设置的线路数量即为线路数
            3. 课程线路数为以上之和
    */
    const { exercises } = program;

    if (exercises.filter((item) => !item.isGroup).every((item) => item.targetType === 2)) {
      if (duration) resData.duration = Math.round(duration / 60);
    } else if (
      // 目标类型 targetType=9 是路线
      // 目标类型 targetType=1 manualEnd 自由模式
      exercises.every((item) => [1, 9].includes(item.targetType))
    ) {
      resData.pitch = pitch;
    } else {
      resData.pitch = pitch;
    }
  }
  // 其他运动
  else {
    if (duration) {
      resData.duration = Math.round(duration / 60);
    }
  }
  return resData;
}
